import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled, { StyledComponent } from 'styled-components';

export const BrandedLink = styled(NavLink)`
 color: #F0403D;
`;

